import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { OperatingSystemRequirements } from 'functions/src/types/firestore/Game/System';
import { GradientTypography } from '../gradients/GradientTypography';

export function DownloadGameSpecs(props: OperatingSystemRequirements) {
  const requirementValues = Object.values(props);
  return (
    <Box sx={{ textAlign: 'left', px: '8px' }}>
      <GradientTypography variant="body1" gradientColor="primary.vertical">
        RECOMMENDED SPECS
      </GradientTypography>
      {requirementValues.map((value) => (
        <Typography
          key={value}
          color="dark.primary.contrast"
          variant="body1"
          sx={{ minHeight: 24 }}
        >
          {value}
        </Typography>
      ))}
    </Box>
  );
}
